/* Coordinate app-rendered product buttons without changing purchase availability. */
(() => {
 const root = document.querySelector('#MainContent');
 if (!root) return;
 const selector = '.timesact-button-cs';
 const styles = {'background-color':'#423048','border':'1px solid #bfa282','border-color':'#bfa282','border-width':'1px','border-radius':'6px','color':'#ff8dca','-webkit-text-fill-color':'#ff8dca','opacity':'1','margin-top':'0px','box-shadow':'none','flex':'1 1 0%','width':'auto','min-width':'0px'};
 const normalized = document.createElement('span').style;
 for (const [property,value] of Object.entries(styles)) normalized.setProperty(property,value,'important');
 const apply = button => {
   for (const property of Object.keys(styles)) {
     const value = normalized.getPropertyValue(property);
     if (button.style.getPropertyValue(property) !== value || button.style.getPropertyPriority(property) !== 'important') button.style.setProperty(property,value,'important');
   }
 };
 const scan = () => root.querySelectorAll(selector).forEach(apply);
 new MutationObserver(records => {
   for (const record of records) {
     if (record.type === 'attributes') {
       if (record.target.matches(selector)) apply(record.target);
     } else if (record.addedNodes.length) scan();
   }
 }).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['style']});
 scan();
})();